import React from 'react';
import clsx from 'clsx';

import collectionHeroStyles from './collectionHero.module.scss';
import { LearningCollection } from '@/types/learning/learning-catalog';
import { getCollectionProviderMeta } from '@/store/providers';
import { RightButtons } from '@/pages/learning/Learning/components/Hero/RightButtons';
import { ProviderIcon } from '@/component/ProviderIcon/ProviderIcon';
import { useCollectionHref } from '@/features/collection/hooks/useCollectionNavigate';

interface Props {
  learningCollection: Readonly<LearningCollection>;
}

export const CollectionHero = ({ learningCollection }: Props): JSX.Element => {
  const providerMeta = getCollectionProviderMeta(learningCollection);
  const collectionsHref = useCollectionHref();

  return (
    <div className="hero is-cls is-padded">
      <div className="hero-body">
        <div className="container">
          <div className="grid">
            <div className="gc gc-8-d gc-8-t gc-12-lp">
              <h1 className={clsx('header1 has-bottom-margin', collectionHeroStyles['course-title'])}>
                {learningCollection.title}
              </h1>
              {learningCollection.teaser && <div className="content preamble">{learningCollection.teaser}</div>}
              <RightButtons
                id={learningCollection.id}
                entity="collection"
                editLink={learningCollection.canEdit ? collectionsHref.adminEditorHref(learningCollection.id) : undefined}
              />
            </div>
            <div className="gc gc-4-d gc-4-t gc-12-lp">
              <div
                className={collectionHeroStyles.image}
                style={learningCollection.imageUrl ? { backgroundImage: `url(${learningCollection.imageUrl})` } : undefined}
              >
                {providerMeta && (
                  <div className={collectionHeroStyles['logo-wrapper']}>
                    <ProviderIcon provider={providerMeta.provider} size="3x" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
